import Layout from "@/page/index/";

export default [
  {
    path: "/wel",
    component: Layout,
    redirect: "/wel/index",
    children: [
      {
        path: "index",
        name: "首页",
        meta: {
          i18n: "dashboard"
        },
        component: () =>
          import(/* webpackChunkName: "views" */ "@/views/wel/index")
      },
      {
        path: "dashboard",
        name: "控制台",
        meta: {
          i18n: "dashboard",
          menu: false
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/wel/dashboard"
          )
      }
    ]
  },
  {
    path: "/test",
    component: Layout,
    redirect: "/test/index",
    children: [
      {
        path: "index",
        name: "测试页",
        meta: {
          i18n: "test"
        },
        component: () =>
          import(/* webpackChunkName: "views" */ "@/views/util/test")
      }
    ]
  },
  {
    path: "/dict-horizontal",
    component: Layout,
    redirect: "/dict-horizontal/index",
    children: [
      {
        path: "index",
        name: "字典管理",
        meta: {
          i18n: "dict"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/util/demo/dict-horizontal"
          )
      }
    ]
  },
  {
    path: "/dict-vertical",
    component: Layout,
    redirect: "/dict-vertical/index",
    children: [
      {
        path: "index",
        name: "字典管理",
        meta: {
          i18n: "dict"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/util/demo/dict-vertical"
          )
      }
    ]
  },
  {
    path: "/info",
    component: Layout,
    redirect: "/info/index",
    children: [
      {
        path: "index",
        name: "个人信息",
        meta: {
          i18n: "info"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/system/userinfo"
          )
      },
      {
        path: "setting",
        name: "个人设置",
        meta: {
          i18n: "info"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/system/setting"
          )
      }
    ]
  },
  {
    path: "/archives/detail",
    component: Layout,
    redirect: "/archives/detail",
    children: [
      {
        path: ":id",
        name: "档案详情",
        meta: {
          i18n: "archives"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/archives/detail"
          )
      }
    ]
  },
  {
    path: "/order",
    component: Layout,
    redirect: "/order/index",
    children: [
      {
        path: "index",
        name: "订单中心",
        meta: {
          i18n: "order"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/order/index"
          )
      },
      {
        path: "detail/success",
        name: "订单详情-结案",
        meta: {
          i18n: "order"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/order/order-detail-success"
          )
      },
      {
        path: "detail/test",
        name: "涉案人个人中心",
        meta: {
          i18n: "order"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/order/order-detail-test"
          )
      },
      {
        path: "detail",
        name: "订单详情",
        meta: {
          i18n: "order"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/order/order-detail"
          )
      },
      {
        path: "dispatch",
        name: "派单",
        meta: {
          i18n: "order"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/order/order-dispatch"
          )
      }
    ]
  },
  {
    path: "/about",
    component: Layout,
    redirect: "/about/index",
    children: [
      {
        path: "index",
        name: "关于我们",
        meta: {
          i18n: "about"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/about/index"
          )
      }
    ]
  },
  {
    path: "/desk",
    component: Layout,
    children: [
      {
        path: "detail",
        name: "编辑基础档案",
        meta: {
          i18n: "desk"
        },
        props: { default: false },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/desk/detail"
          )
      },
      {
        path: "entry",
        name: "完善计划",
        meta: {
          i18n: "desk"
        },
        props: { default: false },
        component: () =>
          import(/* webpackChunkName: "views" */ "@/views/desk/entry")
      },
      {
        path: "progress",
        name: "计划实施",
        meta: {
          i18n: "desk"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/desk/progress"
          )
      }
    ]
  },
  {
    path: "/work/process/leave",
    component: Layout,
    redirect: "/work/process/leave/form",
    children: [
      {
        path: "form/:processDefinitionId",
        name: "请假流程",
        meta: {
          i18n: "work"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/work/process/leave/form"
          )
      },
      {
        path: "handle/:taskId/:processInstanceId/:businessId",
        name: "处理请假流程",
        meta: {
          i18n: "work"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/work/process/leave/handle"
          )
      },
      {
        path: "detail/:processInstanceId/:businessId",
        name: "请假流程详情",
        meta: {
          i18n: "work"
        },
        component: () =>
          import(
                        /* webpackChunkName: "views" */ "@/views/work/process/leave/detail"
          )
      }
    ]
  },
  {
    path: "/project",
    component: Layout,
    redirect: "/project/detail",
    children: [
      {
        path: "/project/detail",
        name: "个案档案",
        meta: {
          i18n: "project"
        },
        component: () => import("@/views/project/detail.vue")
      }
    ]
  }
];
